// extracted by mini-css-extract-plugin
export var label = "_6q-1";
export var reminder = "_6q-0";